export const getKosmosReportLink = (kosmosCompanyId?: string, orgId?: string | null, reportSnapshotId?: string | null): string => {
  const query = [];
  if (orgId) {
    query.push(`organisationId=${orgId}`);
  }
  if (reportSnapshotId) {
    query.push(`reportSnapshotId=${reportSnapshotId}`);
  }
  if (kosmosCompanyId) {
    return `/reports/${kosmosCompanyId || ''}?${query.join('&')}`;
  }
  return '';
};

export const getSgReportLink = (kosmosCompanyId?: string, orgId?: string): string => {
  const query = orgId ? `?organisationId=${orgId}` : '';
  if (kosmosCompanyId) {
    return `/combined-reports/${kosmosCompanyId || ''}${query}`;
  }
  return '';
};
